<template>
  <div class="p-4">
    <button @click="$modal.hide('pending-modal')" class="modal-close-button">
      ❌
    </button>

    <div class="h3 mb-3">Process of cart</div>

    <div class="form">
      <div class="row">
      </div>

      <div class="row mt-2 mb-2">
        <div class="col-lg-12">
          <span>Last comments: </span>
          <ol>
            <li v-for="comment in cart.meta.comment" :key="comment">{{comment}}</li>
          </ol>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-lg-12">
          <div class="form-group col-lg-12">
            <label for="birthdateInput">write a comment:</label>
            <textarea
                v-model="form.comment"
                type="text"
                class="form-control"
                id="birthdateInput"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      class="btn btn-success mt-2 w-100"
      @click.prevent="submit()"
    >
      Confirm
    </button>
  </div>
</template>

<script>
import { config } from "../../../helpers";

export default {
  props: ["cart"],

  data() {
    return {

      form: {
        comment: "",
      },
    };
  },

  methods: {
    submit() {
      axios
        .post(`${config("BACKEND_ROOT")}/admin/carts/${this.cart.id}/pending`, {
          comment: this.form.comment
        })
        .then((response) => {
          this.$emit("done");
          alert("Cart was changed to pending successfully!");
          this.$modal.hide("pending-modal");
        })
        .catch((error) => {
          alert("Something bad happend!");
        });
    },
  },
};
</script>